import { ensureGlobalGa4 } from "./global-ga4";

// Analytics is best-effort and never controls the registration outcome.
export function createConversionTracker(getWindow) {
  const sent = new Set();
  return (registration, eventSlug, globalMeasurementId) => {
    try {
      if (registration?.status !== "confirmed" || typeof registration.id !== "string" || !registration.id.trim()) {
        return false;
      }
      const target = getWindow();
      if (!target || !ensureGlobalGa4(target, globalMeasurementId)) return false;
      const key = `onland:conversion:ga4:v1:${globalMeasurementId}:rsvp_confirmed:${registration.id}`;
      if (sent.has(key)) return false;
      try {
        if (target.sessionStorage?.getItem(key)) return false;
      } catch (error) {
        // Storage may be blocked; the in-memory set still deduplicates this page.
      }
      target.gtag("event", "rsvp_confirmed", {
        send_to: globalMeasurementId,
        page_location: target.location.origin + target.location.pathname,
        registration_id: registration.id,
        event_slug: eventSlug,
        app_source: "metaverse"
      });
      sent.add(key);
      try {
        target.sessionStorage?.setItem(key, "1");
      } catch (error) {
        // A successful push remains recorded in memory when storage is unavailable.
      }
      return true;
    } catch (error) {
      return false;
    }
  };
}

export const trackRsvpConfirmed = createConversionTracker(() => (typeof window === "undefined" ? undefined : window));
